<template>
  <div class="home-container">
    <div class="home-content" v-if="answerFlag">
      <div style="margin: 20px">
         <el-button
          size="small"
          plain
          type="primary"
          icon="el-icon-plus"
          @click="addCharacter"
          style="width: 90px"
          >新增</el-button
        >
        <el-button
          size="small"
          plain
          type="primary"
          @click="back"
          style="width: 90px"
          >返回</el-button
        >
      </div>
      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column prop="title" label="标题" align="center">
        </el-table-column>
        <el-table-column prop="type" label="问题类型" align="center" :formatter="siteType">
        </el-table-column>     
        <el-table-column prop="status" label="是否显示" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              @change="updataStatus(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>   
        <el-table-column  label="问题答案" align="center">
          <template slot-scope="scope">
            <a href="#" @click="bindProblem(scope.row)">问题答案</a>
          </template>
        </el-table-column>                  
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="updataCharacter(scope.row)"
              >修改</el-button
            >

            <el-button @click="del(scope.row)" type="text" size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>        
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
      <!-- 新增模态框 -->
      <el-dialog :title="modalTitle" :visible.sync="isAddModal" width="50%">
        <el-form
          ref="form"
          :model="addData"
          label-width="90px"
          :rules="addDataRules"
          label-position="center"
        >
        <el-row>
            <el-col :span="12">
              <el-form-item label="标题" prop="title">
                <el-input
                  v-model="addData.title"
                  placeholder="请输入问题标题"
                ></el-input>
              </el-form-item> 
            </el-col>    
            <el-col :span="12">
              <el-form-item label="问题类型" prop="type" >
                 <el-select
                  v-model="addData.type"
                  clearable filterable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in siteList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>                     
          </el-row>                                                
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isAddModal = false">取 消</el-button>
          <el-button type="primary" @click="submit" :loading="btnLoading"
            >确 定</el-button
          >
        </span>
      </el-dialog>        
      </div>
    </div>
    <div class="home-content" v-else>
        <questionnaireAnswerList :objId="objId" @answerBack="answerBack"></questionnaireAnswerList>
    </div>
  </div>
</template>

<script>
import reg from '../../utils/reg'
import questionnaireAnswerList from "./questionnaireAnswerList_01.vue";
export default {
  components:{
    questionnaireAnswerList
  },
    props:{
     questionnaireId:Number   
    },
  data() {
    return {
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      tableData: [],
      addData: {
        id: "",
        type:'',
        title:'',
        status:''
      },
      addDataRules: {
        name: [{ required: true, message: "请输入问题名称", trigger: "blur" }],
      },  
      siteList:[
        {
          id:1,
          name:'单选'
        },{
          id:2,
          name:'双选'
        },{
          id:3,
          name:'问答'
        }
      ],
      isShowloading:false,
      isAddModal:false,
      btnLoading:false,
      modalTitle:"",
      answerFlag:true,
      objId:{}
    };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    answerBack(){
      this.answerFlag = true
    },
    // 跳转答案列表
    bindProblem(row){
      this.objId = row
      this.answerFlag = false
    },
    // 修改用户状态
    updataStatus(row) {
      let data = {
        id:row.id,
        status:row.status ? 1 : -1,
        questionnaireId:this.questionnaireId,
        type:row.type,
        title: row.title,        
      }
      this.$Apis.questionnaireTopicAddUp(data).then((res) => {
        if (res.code == 200) {
          this.onLoad();
          this.$message.success("操作成功");
        } else {
          this.$message.warning(res.msg);
        }
      });
    },     
    // 题目类型
    siteType(row){
      if(row.type == 1){
        return '单选'
      }else if(row.type == 2){
        return '双选'
      }else if(row.type == 3){
        return '问答'
      }
    },    
    // 返回活动列表
    back(){
        this.$emit('answerBack',true)
    },
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    // 新增
    addCharacter() {
      for (let item in this.addData) {
        this.addData[item] = "";
      }
      this.modalTitle = "新增"; 
      this.isAddModal = true;
    },  
    // 修改角色
    updataCharacter(row) {  
      this.addData = JSON.parse(JSON.stringify(row));
      this.isAddModal = true;
    },  
    //删除
    del(row) {
      let id = row.id;
      this.$confirm("您确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$Apis.questionnaireTopicDel({ id }).then((res) => {
          if (res.code == 200) {
            this.onLoad();
            this.$message.success("删除成功");
          } else {
            this.$message.warning(res.msg);
          }
        });
      });
    },    
    // 提交
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          var data = {
            id: this.addData.id || "",
            questionnaireId:this.questionnaireId,
            type:this.addData.type,
            title: this.addData.title,
            status:1
          };
          this.$Apis.questionnaireTopicAddUp(data).then((res) => {
            this.btnLoading = false;
            this.isAddModal = false;
            if (res.code == 200) {
              this.onLoad();
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },        
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },    
    onLoad() {
      var data = {
        current: this.currentPage,
        size: this.pageSize,
        questionnaireId:this.questionnaireId
      }
      this.$Apis.questionnaireTopicList(data).then(res=>{
        if (res.code == 200) {
          res.data.forEach(item => {
            item.status = item.status == 1 ? true : false;
          });
          this.tableData = res.data;
        } else {
          this.$message.warning(res.msg);
        }
      })
    },
  },
};
</script>

<style>
</style>